import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useDrag, useDrop } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStream, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import Badge from 'react-bootstrap/Badge';
import itemTypes from '../itemTypes';
import { StyledFieldItem, StyledSubItem } from '../styles';
import { subColumnPropType } from '../../hooks';

function SKDColumnItem({
  subcolumns, onClick, active, name, onDblClick, onHover,
  padded, onSubColumnClick, onChangeHierarchy, onCtxMenu,
}) {
  const ref = useRef(null);
  const [{ isOver }, drop] = useDrop({
    accept: [itemTypes.availableField, itemTypes.column],
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
    hover: (item, monitor) => {
      if (ref.current) {
        const gbcr = ref.current.getBoundingClientRect();
        const cursor = monitor.getClientOffset();
        if ((gbcr.top + gbcr.height / 2) > cursor.y) {
          onHover(name);
        }
      }
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: {
      name,
      type: itemTypes.column,
    },
    type: itemTypes.column,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const style = useMemo(() => ({
    opacity: isDragging ? 0.4 : 1,
  }), [isDragging]);

  drag(drop(ref));
  return (
    <StyledFieldItem
      ref={ref}
      onClick={() => onClick(name)}
      onDoubleClick={() => onDblClick(name)}
      active={active}
      variant={isOver ? 'success' : ''}
      style={style}
      onContextMenu={(e) => onCtxMenu(e, ref.current)}
      data-name={name}
    >
      <StyledSubItem padded={padded} />
      {subcolumns.map((f) => (
        <h5>
          <Badge
            variant={f.errored ? 'danger' : 'light'}
            key={f.name}
          >
            <span
              className="me-2"
            >
              {f.label}
            </span>
          </Badge>
          <Button
            size="sm"
            variant="light"
            onClick={() => onChangeHierarchy(name, f.name, !f.useHierarchy)}
            disabled={!f.canHierarchy}
          >
            <FontAwesomeIcon
              icon={f.useHierarchy ? faStream : faBars}
              title={f.useHierarchy ? 'З ієрархія' : 'Без ієрархії'}
              color="var(--activeColorTextTab)"
            />
          </Button>
          {subcolumns.length > 1 && (
          <FontAwesomeIcon
            icon={faTimes}
            title="Прибрати"
            transform="shrink-6 up-6 left-8"
            color="#b90c0c"
            onClick={() => onSubColumnClick(name, f.name)}
          />
          )}
        </h5>
      ))}
    </StyledFieldItem>
  );
}

SKDColumnItem.propTypes = {
  name: PropTypes.string.isRequired,
  subcolumns: PropTypes.arrayOf(subColumnPropType).isRequired,
  onClick: PropTypes.func.isRequired,
  onSubColumnClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  onHover: PropTypes.func.isRequired,
  padded: PropTypes.bool,
  onChangeHierarchy: PropTypes.func.isRequired,
  onCtxMenu: PropTypes.func.isRequired,
};

SKDColumnItem.defaultProps = {
  active: false,
  padded: false,
};

export default SKDColumnItem;
